class KeyboardHelper {
  /**
   * This method will check if the given event target is an element the user types in (inputs, textareas, selects and editable content),
   * so global keyboard shortcuts can ignore key presses that are meant for that element
   * @param {EventTarget} target
   * @returns {boolean}
   */
  static isEditableTarget(target) {
    if (!(target instanceof Element)) {
      return false;
    }

    if (target.isContentEditable) {
      return true;
    }

    return (
      target.closest(
        'input, textarea, select, [contenteditable="true"], [role="combobox"]',
      ) !== null
    );
  }
}

export default KeyboardHelper;
